import { defineMosaicComponent } from "@/components/Mosaic/defineMosaicComponent";

import type BrandLensSelectBase from "@/components/BrandLensSelect.Base.vue";

export default defineMosaicComponent<typeof BrandLensSelectBase>("components/BrandLensSelect");
